/* Api Endpoints */
// console.log(process.env.IS_PDN);

// DEV cloudfront
// export const SERVER_URL = "https://u79iu4uev0.execute-api.us-east-1.amazonaws.com/dev/tena/";

// PDN cloudfront
export const SERVER_URL = "https://2blh4fqkq6.execute-api.us-east-1.amazonaws.com/pdn/tena/";

// DEV Refresh Token
// export const REFRESH_TOKEN = "https://tena-dev.auth.us-east-1.amazoncognito.com/oauth2/token";

// PDN Refresh Token
export const REFRESH_TOKEN = "https://tena-pdn.auth.us-east-1.amazoncognito.com/oauth2/token";

// DEV Client Id
// export const CLIENT_ID = "5nasqgvvppce004pjtojsfhuea";

// PDN Client Id
export const CLIENT_ID = "57a31p9ich1na2lcjjcpagoalc";


//Register
export const REGISTER_USER_PATH = SERVER_URL + 'register/api/v1/user';
export const REGISTER_RESEND_CODE = SERVER_URL + 'register/api/v1/user/resend-code';
export const CONFIRMATION_REGISTER = SERVER_URL + 'register/api/v1/user/confirmation';
export const REGISTER_PATH = SERVER_URL + 'register/api/v1/register';
export const REGISTER_EMAIL = SERVER_URL + 'register/api/v1/email';
export const REGISTER_CELLPHONE = SERVER_URL + 'register/api/v1/cell-phone';
export const REGISTER_ACCOUNT_INSTITUTION_ID = SERVER_URL + 'register/api/v1/number-id';

//Autentication
export const AUTH_EMAIL = SERVER_URL + 'authentication/api/v1/email';
export const AUTH_LOGIN = SERVER_URL + 'authentication/api/v1/auth';

//Recovery
export const RECOVERY_EMAIL = SERVER_URL + 'recovery/api/v1/email';
export const RECOVERY_PASSWORD = SERVER_URL + 'recovery/api/v1/password/';
export const CHANGE_PASSWORD = SERVER_URL + 'recovery/api/v1/change-password';
export const UPDATE_PROFILE = SERVER_URL + 'account/api/v1/user';

//Account
export const ACCOUNT_POINTS = SERVER_URL + 'accumulation/api/v1/accumulation-detail';
export const ACCOUNT_TOTAL_POINTS = SERVER_URL + 'account/api/v1/user/';
export const ACCOUNT_REDEMPTIONS = SERVER_URL + 'redemption/api/v1/redemptions';

//OTP
export const ACCOUNT_OTP_KEY = SERVER_URL + 'otp/api/v1/get-key';

//Samples
export const SHOW_SAMPLES_SENT = SERVER_URL + 'samples/api/v1/user/samples';
export const SEND_SAMPLES = SERVER_URL + 'samples/api/v1/sample-request';
export const GET_MY_ORDERS = SERVER_URL + 'samples/api/v1/user/orders';
export const GET_FOR_ID_ORDERS = SERVER_URL + 'samples/api/v1/user/orders/detail';

//Benefits
export const BENEFITS_ACCUMULATE = SERVER_URL + 'accumulation/api/v1/key';
export const BENEFITS_VOUCHER_REWARD = SERVER_URL + 'redemption/api/v1/reward';

//Transversal
export const CONTACTUS = SERVER_URL + 'notification/api/v1/contact';

//Products
export const LIKES_PRODUCTS = SERVER_URL + 'rating/api/v1/producto';

//Articles
export const LIKES_ARTICLES = SERVER_URL + 'rating/api/v1/articulo';

//Benefits
export const LIKES_BENEFITS = SERVER_URL + 'rating/api/v1/bono';

//Likes
export const SET_LIKE = SERVER_URL + 'rating/api/v1/like';
export const SET_UNLIKE = SERVER_URL + 'rating/api/v1/unlike';

//Poll
export const POLL_ANSWERS = SERVER_URL + 'poll/api/v1/answer';

//Get ip Address
export const GET_IP_ADDRESS = 'https://jsonip.com/';